import { usePutEnginesIdPreset } from '@/types/origin-point-engine'
import { showErrorData } from '@/lib/toast'
import type { PresetCode } from '@/features/editor/lib/preset'

type BackendResponse<T> = {
  success?: boolean
  data?: T
  message?: string
}

export function useSetEnginePreset() {
  const mutation = usePutEnginesIdPreset({
    mutation: {
      onError: (err: unknown) => {
        const e = err as {
          response?: { data?: { message?: string; error?: string } }
          message?: string
        }
        const msg =
          e?.response?.data?.message ??
          e?.response?.data?.error ??
          e?.message ??
          '设置预设失败'
        showErrorData(msg)
      },
      onSuccess: async (res) => {
        const r = res as { data?: { success?: unknown } }
        const body =
          r?.data?.success !== undefined ? r.data : (res as BackendResponse<unknown>)

        const ok =
          typeof (body as BackendResponse<unknown>)?.success === 'boolean'
            ? Boolean((body as BackendResponse<unknown>).success)
            : true

        if (!ok) {
          showErrorData(
            (body as BackendResponse<unknown>)?.message ?? '设置预设失败'
          )
          return
        }

        // 这里按你项目实际 queryKey 补（引擎详情/编辑器初始化/草稿等）
        await Promise.all([
          // queryClient.invalidateQueries({ queryKey: getGetEnginesIdQueryKey(engineId) }),
        ])
      },
    },
  })

  const setEnginePreset = (input: {
    engineId: string
    presetCode: PresetCode
  }) => {
    return mutation.mutateAsync({
      id: input.engineId,
      data: { presetCode: input.presetCode },
    })
  }

  return {
    setEnginePreset,
    isPending: mutation.isPending,
  }
}
